export class TipoEntidadI{
  id:BigInteger;
  codigo:String;
  nombre:String;
  idSuper:String;
}
